var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeartBuyPrompt = function SvgIconHeartBuyPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M10.373 6.614a3.674 3.674 0 0 0-5.272 0 3.893 3.893 0 0 0 0 5.427l6.185 6.304a1 1 0 0 0 1.428 0l6.185-6.304a3.893 3.893 0 0 0 0-5.427 3.674 3.674 0 0 0-5.272 0l-.913.931a1 1 0 0 1-1.428 0zm1.427-1.4.2.203.2-.203a5.674 5.674 0 0 1 8.126 0c2.232 2.274 2.232 5.954 0 8.228l-6.185 6.303a3 3 0 0 1-4.282 0l-6.185-6.303c-2.232-2.274-2.232-5.954 0-8.228a5.674 5.674 0 0 1 8.126 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeartBuyPrompt;